import { useState, useEffect, useCallback } from 'react';

interface ITimerCounter {
  formattedTime: string;
  time: number;
  startTimer: () => void;
  stopTimer: () => void;
  resetTimer: () => void;
}

export const useElapsedTime = (): ITimerCounter => {
  const [isRunning, setIsRunning] = useState(false);
  const [time, setTime] = useState(0); // Time in seconds

  useEffect(() => {
    let timer: ReturnType<typeof setInterval> | null = null;
    if (isRunning) {
      timer = setInterval(() => {
        setTime(prevTime => prevTime + 1);
      }, 1000);
    }
    return () => {
      if (timer) clearInterval(timer);
    };
  }, [isRunning]);

  const formatTime = (timeInSeconds: number) => {
  const [hours, minutes, seconds] = [
    Math.floor(timeInSeconds / 3600),
    Math.floor((timeInSeconds % 3600) / 60),
    timeInSeconds % 60,
  ].map(unit => unit.toString().padStart(2, '0'));
    return `${hours}:${minutes}:${seconds}`;
  };

  const startTimer = useCallback(() => setIsRunning(true), []);
  const stopTimer = useCallback(() => setIsRunning(false), []);
  const resetTimer = useCallback(() => {
    setIsRunning(false);
    setTime(0);
  }, []);

  return { formattedTime: formatTime(time), time, startTimer, stopTimer, resetTimer };
};

export default useElapsedTime;
